<template>
  <v-dialog
    v-model="enable"
    max-width="350"
    persistent
    class="main--text"
    >
    <v-card
      v-if="inProgress"
    >
      <v-card-title
        class="headline">
        登録中です
      </v-card-title>
      <v-card-text>
        現在メールアドレスの登録中です。しばらくお待ち下さい。
      </v-card-text>
      <v-card-actions>
        <v-progress-linear
        :indeterminate="true"
        color="primary"
        />
      </v-card-actions>
    </v-card>
    <v-card
      v-else
    >
      <v-card-title
        class="headline">
        確認メールを送信しました
      </v-card-title>
      <v-card-text>
        メールを確認し、詳細情報の登録を行ってください。
      </v-card-text>
      <v-card-actions>
        <v-row
          justify="space-around">
          <v-col
            cols="auto">
            <v-btn
              rounded
              outlined
              @click="$emit('resend-button-click')"
            >
              メール再送信
            </v-btn>
          </v-col>
          <v-col
            cols="auto">
            <v-btn
              rounded
              outlined
              color="primary"
              @click="$emit('finish-button-click')"
            >
              ログインページへ
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    enable: {
      type: Boolean,
      default: false,
      required: true
    },
    inProgress: {
      type: Boolean,
      default: true,
      required: true
    }
  }
}
</script>
